import { render, staticRenderFns } from "./RegistrationIntro.vue?vue&type=template&id=6dd10774&scoped=true&"
import script from "./RegistrationIntro.vue?vue&type=script&lang=js&"
export * from "./RegistrationIntro.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationIntro.vue?vue&type=style&index=0&id=6dd10774&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd10774",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/usr/src/regapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
installComponents(component, {VAlert,VFlex,VIcon,VLayout,VSpacer})
